import styled from 'styled-components';

export const Greeneries = styled.div`
  background: white;
  min-height: 100%;
`
